module.exports = {"data":{"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Hello world.\n","fields":{"slug":"/hello-world/"},"frontmatter":{"date":"03 July, 2018","title":"Hello World","tags":["tag-1","tag-2","sample"]}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog.json
// module id = 412
// module chunks = 49683490770531